declare namespace $ {

	export class $mol_icon_hand extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=hand.view.tree.d.ts.map